<template>
  <v-container
    fluid
  >
    <!-- Settings List -->
    <v-row>
      <v-col cols="12">
        <v-list
          three-line
          subheader>
          <v-subheader>Login Information</v-subheader>
          <v-list-item
            v-ripple>
            <v-list-item-content @click="passwordChangeDialog = true">
              <v-list-item-title>Password</v-list-item-title>
              <v-list-item-subtitle>Click here to change your password</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-subheader v-if="showNotificationsSettings">Notification settings</v-subheader>
          <v-list-item
            v-ripple
            v-if="showNotificationsSettings">
            <v-list-item-action>
              <v-checkbox
                color="primary"
                v-model="notifCheckbox"
                @change="toggleSubscription()"/>
            </v-list-item-action>
            <v-list-item-content @click="toggleSubscription()">
              <v-list-item-title>Enable Notifications</v-list-item-title>
              <v-list-item-subtitle>Be notified when new content is available to view</v-list-item-subtitle>
              <v-alert
                type="info"
                v-if="notifCheckbox != true"
                outlined
              >
                <div class="mb-2">To receive notifications, please enable them in your device settings first:</div>
                <v-chip
                  x-small
                  class="mr-1">Settings</v-chip>
                <v-icon x-small>mdi-chevron-right</v-icon>
                <v-chip
                  x-small
                  class="mx-1">Apps</v-chip>
                <v-icon x-small>mdi-chevron-right</v-icon>
                <v-chip
                  x-small
                  class="mx-1">@school</v-chip>
                <v-icon x-small>mdi-chevron-right</v-icon>
                <v-chip
                  x-small
                  class="mx-1">Notifications</v-chip>
                <v-icon x-small>mdi-chevron-right</v-icon>
                <v-chip
                  x-small
                  color="primary"
                  class="mx-1">Allow Notifications</v-chip>
              </v-alert>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-ripple
            @click="toggleEmailSubscription()">
            <v-list-item-action>
              <v-checkbox
                color="primary"
                v-model="emailNotificationCheckbox"/>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Enable Email Notifications</v-list-item-title>
              <v-list-item-subtitle>Be notified by email when new content is available to view</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card>
            <v-list-item v-if="withSetup">
              <v-list-item-icon>
                <v-icon color="gray">vpn_key</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>PinCode</v-list-item-title>
                <v-list-item-subtitle>Create PinCode/Activate</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-icon @click.stop="pinCodeDialog = true">
                <v-icon color="orange">edit</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item v-else>
              <v-list-item-icon>
                <v-icon color="gray">vpn_key</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{ textToShow }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-icon >
                <v-icon color="gray">edit</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-card>
        </v-list>
        <v-card v-if="withSetup">
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="gray">vpn_key</v-icon>
            </v-list-item-icon>

            <v-list-item-content
              @click.once="disablePinCodeDialog">
              <v-list-item-title>Disable PinCode</v-list-item-title>
              <v-list-item-subtitle>Click here to disable the PinCode feature</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
        <v-dialog
          v-model="pinCodeDialog"
          max-width="500px">
          <v-card>
            <v-card-title>Pin Code Update</v-card-title>
            <v-divider/>
            <v-row class="pa-4">
              <v-col>
                <v-form
                  ref="form"
                  v-model="isItValid"
                  lazy-validation
                >
                  <v-alert
                    v-model="error"
                    dismissible
                    color="red"
                    icon="warning"
                    outlined
                  >
                    {{ errorMsg }}
                  </v-alert>
                  <v-text-field
                    v-model="changePinCode"
                    :rules="pincodeRules"
                    @keyup.enter="editPinCode()"
                    id="password"
                    name="password"
                    label="Enter your new pincode"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    :class="{ 'hide-input': !showPassword }"
                    required
                    solo
                  />
                </v-form>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-btn
                color="error"
                dark
                @click="cancelPinCode()"
              >
                Cancel
              </v-btn>
              <v-spacer/>
              <v-btn
                :disabled="!isItValid"
                @click="editPinCode()"
                :color="isItValid ? 'rgb(0, 176,185)' : 'grey'"
              >
                <span :class="[{'white--text': isItValid }]">Update</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <!-- Change Password Dialog -->
    <change-password
      :password-change-dialog="passwordChangeDialog"
      @closedialog="passwordChangeDialog = false" />
  </v-container>
</template>

<script>
import ChangePassword from '../components/ChangePassword'

export default {
  data: () => ({
    notifications: false,
    emailNotificationText: false,

    passwordChangeDialog: false,
    isAppleSubscribed: false,
    test: {},
    textToShow: 'Create Pin Code/Activate',
    pinCodeDialog: false,
    pincodeRules: [
      v => (v && v.length === 4) || 'This field only accepts 4 digit pincode',
      v => /^\d+$/.test(v) || 'This field only accept numbers'
    ],
    isItValid: false,
    error: false,
    errorMsg: '',
    withSetup: true,
    changePinCode: '',
    showOldPinCode: false,
    showPassword: false
  }),

  components: {
    ChangePassword
  },

  created: function () {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(this.$store.state.appleSubscriptionToken)
      this.$http.post('caregiversV2/' + this.$store.state.Dbasename + '/' + this.$store.state.userId + '/appleSubscriptionStatusV2', {
        'subscription': this.$store.state.appleSubscriptionToken
      })
        .then(resp => {
          this.isAppleSubscribed = resp.data.subscribed
          this.$store.commit('update_apple_subscription_token', this.$store.state.appleSubscriptionToken)
        })
    } else {
      window.pushHelper.checkSubscription(window.pushHelper.registration)
      this.notifications = window.pushHelper.isSubscribed
      console.log(this.notifications)
      console.log('created')
    }
  },

  mounted: function () {
    // this.$http.get('https://www.atschool.co.nz/api/v2/caregivers/' + this.$store.state.userId + '/getEmailSubscriptionStatus')
    this.$http.get('caregiversV2/' + this.$store.state.Dbasename + '/' + this.$store.state.trueUser + '/getEmailSubscriptionStatusV2')
      .then(resp => {
        this.emailNotificationText = resp.data.subscribed
      })

    setTimeout(() => {
      this.$store.commit('loading', false)
    }, 250)
    this.$store.commit('toggle_dialog', true)
  },

  computed: {
    userId: function () {
      return this.$store.state.schoolId + '/' + this.$store.state.pupilId + '/' + this.$store.state.userId
    },
    isAppleSubscribed: function () {
      return this.$store.state.isAppleSubscribed
    },
    notifCheckbox: function () {
      if (window.ReactNativeWebView) {
        return this.isAppleSubscribed
      } else {
        return window.pushHelper.isSubscribed
      }
    },
    emailNotificationCheckbox: function () {
      return this.emailNotificationText
    },

    appleSubscriptionToken: function () { return this.$store.state.appleSubscriptionToken },
    showNotificationsSettings: function () {
      let userAgent = window.navigator.userAgent
      return window.ReactNativeWebView || (!userAgent.match(/iPad/i) && !userAgent.match(/iPhone/i))
    },
    schoolName: function () {
      return this.$store.state.schoolName
    }
  },
  methods: {
    async showMessage (message) {
      await this.$swal({
        icon: 'success',
        title: 'Success',
        text: message
      })
    },
    checkAgain: function () {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(this.$store.state.appleSubscriptionToken)
        this.$http.post('caregiversV2/' + this.$store.state.Dbasename + '/' + this.$store.state.userId + '/appleSubscriptionStatusV2', {
          'subscription': this.$store.state.appleSubscriptionToken
        })
          .then(resp => {
            this.isAppleSubscribed = resp.data.subscribed
            this.$store.commit('update_apple_subscription_token', this.$store.state.appleSubscriptionToken)
          })
      } else {
        window.pushHelper.checkSubscription(window.pushHelper.registration)
        this.notifications = window.pushHelper.isSubscribed
      }
    },
    toggleSubscription: function () {
      // If not subscribed to push notifications, subscribe
      if (window.pushHelper.registration !== null) {
        // this.checkAgain()

        if (this.notifications === false) {
          this.notifications = true
          console.log('subscribing')
          window.pushHelper.subscribe(this.$store.state.userId, this.$store.state.schoolId)
          // window.pushHelper.subscribe(this.$store.state.trueUser, this.$store.state.schoolId)
        } else {
          this.notifications = false
          console.log('unsubscribing')
          window.pushHelper.unsubscribe()
        }
      } else if (window.ReactNativeWebView) { // Apple iOS app notifications
        if (!this.isAppleSubscribed) {
          console.log('subscribing')
          window.ReactNativeWebView.postMessage('subscribeNotifications')
        } else {
          console.log('unsubscribing')
          window.ReactNativeWebView.postMessage('unsubscribeNotifications')
        }
      }
    },

    toggleEmailSubscription: function () {
      this.$http.post('registerEmailSubscriptionV2/' + this.$store.state.Dbasename, {
        'is_active': !this.emailNotificationText,
        // 'caregiverId': this.$store.state.userId,
        'caregiverId': this.$store.state.trueUser,
        'schoolId': this.$store.state.schoolId
      })
        .then(resp => {
          this.emailNotificationText = resp.data.is_active
        })
    },

    cancelPinCode: async function () {
      this.pinCodeDialog = false
      this.error = false
      this.errorMsg = ''
      this.changePinCode = ''
    },

    editPinCode: async function () {
      try {
        if (this.changePinCode === '') {
          this.error = true
          this.errorMsg = 'Please enter a pincode'
          return
        }

        if (this.$refs.form.validate()) {
          const resp = await this.$http.post('caregiversV2/' + this.$store.state.Dbasename + '/' + this.$store.state.userId + '/addPinCodeV2', {
            newpincode: this.changePinCode
          })

          if (resp.data.response !== 'Success') {
            this.changePinCode = ''
            this.$store.commit('loading', false)
            location.reload()
          } else {
            this.$store.commit('with_pin_code_status', resp.data.with_pin_check)
            this.changePinCode = ''
            this.textToShow = 'Change Pin code'
            this.$store.commit('loading', false)
            this.pinCodeDialog = false
          }
        }
      } catch (error) {
        console.error('Error in editPinCode:', error)
      }
    },

    disablePinCodeDialog: async function () {
      const withPinStatus = this.$store.state.withPin
      console.log(withPinStatus)
      if (withPinStatus === false) {
        this.showMessage('Already Disabled')
        return
      }

      try {
        const resp = await this.$http.post('caregivers/' + this.$store.state.userId + '/disablePinCode')
        if (resp.data.response !== 'Success') {
          this.$store.state.withPin = false
          this.showMessage('The pin has been successfully disabled.')
        }
      } catch (error) {
        console.error('Error in disablePinCodeDialog:', error)
      }
    },

    showAlert (msg) {
      this.$swal(msg)
    }
  }
}
</script>

<style scoped>
.v-list--three-line .v-list-item .v-list-item__action {
  align-self: auto;
}
</style>
